<template>
  <div
    class="playing icon-sm flex gap-0.5 items-center justify-between box-border h-4 w-4 before:h-full before:w-0"
  >
    <span
      v-for="i in 3"
      :key="i"
      :class="`playing-bar-${i + 1}`"
      class="inline-block bg-current rounded w-1/3 h-full playing-bar"
    />
  </div>
</template>
<style>
.playing-bar {
  animation: up-and-down 1.3s ease infinite alternate;
}

.playing-bar-1 {
  height: 60%;
}

.playing-bar-2 {
  height: 30%;
  animation-delay: -2.4s;
}

.playing-bar-3 {
  height: 75%;
  animation-delay: -3.7s;
}

@keyframes up-and-down {
  10% {
    height: 30%;
  }
  30% {
    height: 100%;
  }
  60% {
    height: 50%;
  }
  80% {
    height: 75%;
  }
  100% {
    height: 20%;
  }
}
</style>
